
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 50 50"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"24.89","cy":"24.89","r":"23.6","fill":"#fff","stroke":"#515358","stroke-miterlimit":"10","stroke-width":"1.2"}}),_c('path',{attrs:{"d":"M37.94 25.61a1.73 1.73 0 01-1.44.5v11.12A1.75 1.75 0 0134.75 39H15a1.75 1.75 0 01-1.75-1.75V26.08a1.75 1.75 0 01-1.39-3l11.77-11.77a1.76 1.76 0 012.48 0l11.83 11.82a1.76 1.76 0 010 2.48z","fill":"#515358"}})])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/tools_svgs/uni.svg